



















import Vue from 'vue';
import { TextCard } from './resource-bucket-components';

import { getContentArea } from '@/contentful';

interface Data {
  column1_content: false;
  column2_content: false;
  column3_content: false;
}

export default Vue.extend({
  name: 'ThreeResourceBuckets',
  props: {
    column1: {
      type: String,
      required: true,
    },
    column2: {
      type: String,
      required: true,
    },
    column3: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      column1_content: false,
      column2_content: false,
      column3_content: false,
    };
  },
  beforeMount() {
    if (this.column1) {
      getContentArea(this.column1).then((data) => {
        if (data && data.fields) {
          this.column1_content = data.fields;
        }
      });
    }
    if (this.column2) {
      getContentArea(this.column2).then((data) => {
        if (data && data.fields) {
          this.column2_content = data.fields;
        }
      });
    }
    if (this.column3) {
      getContentArea(this.column3).then((data) => {
        if (data && data.fields) {
          this.column3_content = data.fields;
        }
      });
    }
  },
  components: {
    TextCard,
  },
});
